import { render, staticRenderFns } from "./_Comments.vue?vue&type=template&id=7de009d8&scoped=true&"
import script from "./_Comments.vue?vue&type=script&lang=js&"
export * from "./_Comments.vue?vue&type=script&lang=js&"
import style0 from "./_Comments.vue?vue&type=style&index=0&id=7de009d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7de009d8",
  null
  
)

export default component.exports